import { render } from "./unicode_domain_indicator.vue?vue&type=template&id=3e044e46"
import script from "./unicode_domain_indicator.vue?vue&type=script&lang=js"
export * from "./unicode_domain_indicator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__